import { useEffect, useState } from 'react'
import { Skeleton } from '@chakra-ui/react'

import { Jobsite } from 'InstitutionalManagement/types'
import JobsiteCard from 'InstitutionalManagement/components/JobsiteCard'
import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'
import getJobsiteOnCustomForm from './services/getJobsiteOnCustomForm'

export default function CustomFormAnswerJobsite() {
  const [loadingJobsite, setLoadingJobsite] = useState<boolean>(false)
  const [jobsite, setJobsite] = useState<Jobsite>({})

  const { answer } = useCustomFormAnswer()

  const answerValue = answer.answer ? answer.answer[0] : ''

  const jobsiteId: string = answerValue

  async function getJobsite() {
    setLoadingJobsite(true)
    const response = await getJobsiteOnCustomForm({ jobsiteId })
    if (response?.header?.success) {
      const jobsiteFromAPI = response?.body?.jobsite
      setJobsite(jobsiteFromAPI)
    }
    setLoadingJobsite(false)
  }

  useEffect(() => {
    if (answerValue) getJobsite()
  }, [answerValue])

  return (
    <Skeleton isLoaded={!loadingJobsite}>
      <JobsiteCard borderWidth="1px" borderColor="borderColor" jobsite={jobsite} />
    </Skeleton>
  )
}
